module.exports = __webpack_public_path__ + "img/plan5_s.80ef76d7.svg";